import { Service } from '@/services/api';

export interface Tag {
  id: number;
  name: string;
}

class TagService extends Service {
  async getTags(): Promise<Tag[]> {
    return this.get<Tag[]>(`/v2/tags`).then(this.handleResponse);
  }
}

export default new TagService();
